import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import AddonsConfigurator from 'src/components/AddonsConfigurator';
import Checkbox from 'src/components/Checkbox';

import theme from 'src/styles/components/Addon.module.scss';

const CheckboxAddons = ({ virtualId, addons, onSelectAddon, onUnselectAddon }) => {
    const intl = useIntl();

    const handleChange = useCallback((addon) => {
        if (!addon.quantity > 0) {
            onSelectAddon(addon.virtualId, { quantity: 1 });
        } else {
            onUnselectAddon(addon.virtualId, { quantity: 0 });
        }
    });

    const selectedAddons = addons.filter((addon) => addon.quantity > 0);

    return (
        <>
            <div name={virtualId}>
                {addons.map((addon) => (
                    <Checkbox
                      key={addon.virtualId}
                      disabled={!addon.maxQuantity}
                      label={(
                          <span className={theme.addonDescription}>
                              <div>{addon.name}</div>
                              {Boolean(addon.price) && (
                                  <div className={theme.price}>
                                      {'+ '}
                                      {intl.formatNumber(addon.price, { style: 'currency', currency: 'PLN' })}
                                  </div>
                              )}
                          </span>
                      )}
                      value={addon.virtualId}
                      checked={addon.quantity > 0}
                      onChange={() => { handleChange(addon); }}
                    />
                ))}
            </div>
            <div className={theme.nested}>
                {selectedAddons.map((addon) => (
                    <Fragment key={addon.virtualId}>
                        {addon.addonGroups.map((addonGroup) => (
                            <AddonsConfigurator key={addonGroup.virtualId} {...addonGroup} />
                        ))}
                    </Fragment>
                ))}
            </div>
        </>
    );
};

CheckboxAddons.propTypes = {
    addons: PropTypes.arrayOf(PropTypes.shape({
        addonGroups: PropTypes.arrayOf(PropTypes.object),
        id: PropTypes.string.isRequired,
        maxQuantity: PropTypes.number.isRequired,
        minQuantity: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        parentProductId: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        productId: PropTypes.string.isRequired,
        virtualId: PropTypes.string.isRequired
    })),
    maxQuantity: PropTypes.number.isRequired,
    virtualId: PropTypes.string.isRequired,
    onSelectAddon: PropTypes.func.isRequired,
    onUnselectAddon: PropTypes.func.isRequired
};

export default CheckboxAddons;
